module.exports = __webpack_public_path__ + "static/media/check-double.7ececfd1.svg";